import MuiAlert, {AlertProps} from '@mui/material/Alert';
import React from 'react';

/**
 * Alert message component
 * @component
 */
const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
	return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default Alert;
